import InputType from "@/services/Input/InputType.js";
import Catalog from "../DispatchCatalog.js";

// see details: "@/services/Input/DataCatalog.js"
export default {
  Search: {
    Label: "Cari " +
      Catalog.FullName.Label + ", atau " +
      Catalog.SKU.Label,
    Type: InputType.Text,
    MaxLength: 100
  }
}